export default __webpack_public_path__ + "7201a4e0afcc6ad8cb25f270ddd88c15.webp";